export default {
  PRIVILEGE_NAME: {
    USER: "USER",
    VACANT: "VACANT",
    PRODUCT: "PRODUCT",
    POST: "POST",
    SOCIAL_MEDIA: "SOCIAL-MEDIA",
    SECTION: "SECTION",
    BUDGET: "BUDGET",
    AUDIT: "AUDIT",
    SERVICE: "SERVICE",
    LANGUAGE: "LANGUAGE",
    SETTING_PAGE: "SETTING-PAGE",
    SETTING_PHOTO: "SETTING-PHOTO",
    LICENSE: "LICENSE",
    CONTACT: "CONTACT",
  },
  PRIVILEGE_TYPE: {
    CREATE: "C",
    READ: "R",
    UPDATE: "U",
    DELETE: "D",
  },
  STATUS: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    DELETED: "DELETED",
  },
  PHOTO_TYPE: {
    CAROUSEL: "CAROUSEL",
    CLIENT: "CLIENT",
  },
  PHOTO_KIND: {
    VIDEO: "VIDEO",
    PHOTO: "PHOTO",
  },
  CONTACT_TYPE: {
    BILLBOARD: "billboard",
    CONTACT_US: "contact-us",
  },
  TABLE: {
    SERVICE: "CB_SERVICE",
    VACANT: "CB_VACANT",
    POST: "CB_POST",
    SECTION: "CB_SECTION",
    PRODUCT: "CB_PRODUCT",
    PHOTO: "CB_PHOTO",
  },
  ITEMS_PER_PAGE: 5,
  ITEMS_PER_PAGE_CLIENT: 6,
};
